<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>
      <h1>Accountant nodig? Vergelijk ze!</h1>
      <p>
        Ondernemers zijn wettelijk verplicht tot het voeren van een
        administratie, het indienen van belastingaangiftes en het opstellen van
        een jaarrekening. Maar wilt u zich vooral bezighouden met het laten
        slagen van uw onderneming en u geen zorgen maken over deze bijzaken? Uw
        juridische en financiële zaken kunt u overdragen aan een account. Deze
        heeft de juiste expertise in huis om er voor te zorgen dat uw
        onderneming juridisch en financieel goed op orde is. Hij of zij
        adviseert en begeleidt u zodat u alle controles glansrijk zult
        doorstaan. Omdat ieder accountant zijn eigen werkwijze en tarieven
        heeft, is het verstandig meerdere offertes aan te vragen.
      </p>
      <p>
        Uw financiële administratie uit handen geven? Dat doet u als ondernemer,
        ZZP’er of particulier nooit zomaar. Veel mensen proberen daarom alles
        zelf te doen en zo ook te besparen op hun accountantkosten. Maar omdat
        ondernemers, ZZP’ers en particulieren vaak te weinig tijd hebben, of
        niet over de juiste kennis beschikken, schiet de administratie er wel
        eens bij in of wordt deze slecht gedaan. Handig is het dan ook om de
        gehele administratie over te dragen aan professionals. En dat hoeft niet
        eens zo duur te zijn!
      </p>

      <h2>De diensten</h2>
      <p>
        Maar wat doet een accountant nou concreet? Accountants nemen voor alle
        ZZP’ers, mkb’ers en particulieren hun complete administratie,
        jaarrekening en fiscale aangiftes professioneel uit handen. Naast het
        verzorgen van de loonadministratie en belastingen zoals de
        omzetbelasting en inkomstenbelasting, geeft een accountant u ook advies
        over fiscale zaken. In feite kunt u bij deze financieel adviseur terecht
        met alle vragen die betrekking hebben op uw (toekomstige) onderneming.
        Deze zaken kunt u gerust uitbesteden, omdat accountants professionals op
        het gebied van financiële administratie zijn. Ook als u ZZP’er of
        particulier bent is het handig om uw administratie uit te besteden. Voor
        deze groepen bieden accountants verschillende mogelijkheden aan.
      </p>
      <p>Lees er hier meer over:</p>
      <p>
        -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <nuxt-link
          to="/informatie-over-accountants/accountants-voor-particulieren"
        >
          Wat kan een accountant doen voor particulieren?
        </nuxt-link>
      </p>
      <p>
        -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <nuxt-link to="/informatie-over-accountants/accountants-voor-bedrijven">
          Wat kan een accountant doen voor bedrijven en ZZP'ers?
        </nuxt-link>
      </p>
      <p>
        Omdat er jaarlijks veel belangrijke financiële verplichtingen op u
        afkomen – belastingen, loonadministratie, financiële administratie en
        jaarafrekeningen – wilt u graag samenwerken met een accountant die u
        compleet vertrouwt. Financiële gegevens zijn boven alles persoonlijke en
        vertrouwelijke informatie.
      </p>

      <h2>AA- of RA-accountant</h2>
      <p>Er zijn twee type accountants waar u mee in zee kunt gaan:</p>
      <p>
        -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <nuxt-link to="/informatie-over-accountants/aa-accountant">
          AA-accountant
        </nuxt-link>
      </p>
      <p>
        -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <nuxt-link to="/informatie-over-accountants/ra-accountant">
          RA-accountant
        </nuxt-link>
      </p>
      <p>
        Beide hebben nagenoeg gelijke bevoegdheden. Het verschil is dat een
        RA-accountant universitair is opgeleid en dat een AA-accountant ook een
        hbo-opleiding kan hebben. Een AA-accountant is vooral werkzaam in het
        mkb, RA-accountant zitten veelal bij de overheid of multinationals. Om
        er voor te zorgen dat u de juiste keuze maakt, is het verstandig
        accountants met elkaar te vergelijken. Ook met het oog op de tarieven,
        is dit een aanrader.
      </p>

      <h2>Offertes aanvragen</h2>
      <p>
        Iedere accountant heeft zijn eigen tarieven: zo betaalt u bij sommige
        per uur en bij andere per klus. Om niet voor verassingen te komen staan,
        is het verstandig allereerst op een rij te zetten wat u graag uit wilt
        besteden om vervolgens via offertes uw wensen bij accountants neer te
        leggen. Via Accountantvergelijker.nl kunt u geheel vrijblijvend 6
        offertes aanvragen bij accountants in uw postcodegebied. Profiteer van
        die kans en vind de accountant die het beste bij u past!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks.vue'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Op zoek naar een accountant?',
      description:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van vakkundige Bedrijven uit jouw regio ✓ Dé beste prijs voor jouw Reparatie ✓ Bespaar tot 40%',
    }
  },
}
</script>
